/**
 * Single source of truth for deriving the per-catalog ``catalogAliId`` query
 * param to send to write-side endpoints (upload-initiate, keywords-save, and
 * any future write that may mint a catalog number).
 *
 * Rule: a non-null ``activeCatalogOwnerId`` means the user is acting under a
 * delegation — the backend routes via the ``owner_id`` query param to the
 * delegator's primary catalog, so we must NOT also send ``catalogAliId``
 * (the delegator's ownership of the requested LL-NXX is what the backend
 * authorizes against, not the delegate's). Otherwise (own primary or own
 * add-on selected), forward the active catalog's LL-NXX so the backend mints
 * under that catalog instead of defaulting to the user's primary.
 *
 * Extracted from the inline ternary at ``UploadObject.tsx:304`` so the rule
 * stays consistent across multiple call sites — the partial migration that
 * caused the JT-335-mints-as-RA-8JY bug originated in part because the rule
 * was only applied at the upload site.
 *
 * See ``ActiveCatalogContext.tsx:33-35`` and ``336-338`` for the documented
 * semantics of ``activeCatalogOwnerId`` (null for own catalogs, non-null only
 * when a delegated catalog is selected).
 */
export const resolveCatalogAliIdForRequest = (
  activeCatalogAliId: string | null,
  activeCatalogOwnerId: string | null,
): string | null => (activeCatalogOwnerId ? null : activeCatalogAliId);
